import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function _1kPlusIcon(props: IconProps) {
    return <Icon {...props} iconKey={"1k_plus"}/>
}
